/* Track Order page: checks the AWB number, then opens Shiprocket tracking in a new tab. */
(function () {
  var MSG_EMPTY = 'Please enter your AWB number.';
  var MSG_ORDER = "This looks like an order number. Please use 'Track with Order ID or phone' below.";
  var MSG_CHECK = 'Please check the AWB number and try again.';

  // window.open with the 'noopener' feature always returns null, so a blocked popup could not be
  // told apart from a tab that opened. Open first, then cut the opener link before the page loads.
  function openTracking(url) {
    var win = window.open(url, '_blank');
    if (win) {
      win.opener = null;
    } else {
      location.href = url;
    }
  }

  document.querySelectorAll('[data-tk-track]').forEach(function (root) {
    var form = root.querySelector('[data-tk-form]');
    var input = root.querySelector('[data-tk-input]');
    var msg = root.querySelector('[data-tk-msg]');
    var lookup = root.querySelector('[data-tk-lookup]');
    var template = root.getAttribute('data-awb-template');

    function clearMessage() {
      msg.textContent = '';
      input.removeAttribute('aria-invalid');
      lookup.classList.remove('tk-card--hl');
    }

    function showError(text) {
      msg.textContent = text;
      input.setAttribute('aria-invalid', 'true');
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      clearMessage();

      var value = input.value.replace(/\s+/g, '').replace(/^#+/, '');

      if (!value) {
        showError(MSG_EMPTY);
      } else if (/^\d{1,7}$/.test(value)) {
        showError(MSG_ORDER);
        lookup.classList.add('tk-card--hl');
        // Close the phone keyboard so the highlighted card can be seen
        input.blur();
        lookup.scrollIntoView({
          block: 'nearest',
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      } else if (!/^[A-Za-z0-9]{8,25}$/.test(value)) {
        showError(MSG_CHECK);
      } else {
        openTracking(template.replace('[code]', encodeURIComponent(value)));
      }
    });

    input.addEventListener('input', clearMessage);
  });
})();
